import { io } from "socket.io-client";

const socket = io(
    "https://homefoods-backend-production.up.railway.app",
    {
        transports: ["websocket", "polling"],
    }
);

export default socket;